module.exports = new __parcel__URL__("favicon-temp-csm.54dd99fd.png").toString();